import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Typography,
  Alert,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { createSupportRequest } from "../../redux/supportSlice";
import { getCurrentUser } from "../../redux/userSlice";
import UserSideBar from "../../common/UserSidebar/UserSideBar";

const UserSupportPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.support);
  const { currentUser } = useSelector((state) => state.users);
  
  const [form, setForm] = useState({ topic: "", description: "" });
  const [success, setSuccess] = useState(false);

  // Component mount olduğunda current user bilgilerini çek
  useEffect(() => {
    if (!currentUser) {
      dispatch(getCurrentUser());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess(false);
    
    if (!currentUser) {
      console.error("Current user not found");
      return;
    }
    
    const supportData = {
      fullName: currentUser.name + " " + currentUser.lastName,
      email: currentUser.email || "",
      topic: form.topic,
      description: form.description
    };
    
    try {
      await dispatch(createSupportRequest(supportData)).unwrap();
      setForm({ topic: "", description: "" });
      setSuccess(true);
      
      // Success mesajını 3 saniye sonra gizle
      setTimeout(() => setSuccess(false), 3000);
    } catch (error) {
      console.error("Support request failed:", error);
    }
  };

  return (
    <>
      <div className="flex flex-col md:flex-row min-h-screen mt-[-20px] p-2">
        <UserSideBar className="w-full md:w-64 mb-4 md:mb-0" />
        <Box className="flex-1 max-w-5xl px-4 md:px-10 lg:px-16 py-6 md:py-10 flex flex-col">
          <Typography variant="h4" gutterBottom>
            {t("support")}
          </Typography>
          <Typography variant="body2" className="text-gray-600 mb-6">
            If you have any questions or encounter a problem, you can reach us here. Our support team will get back to you as soon as possible.
          </Typography>

          {success && (
            <Alert severity="success" className="mb-4">
              {t("supportRequestSent") || "Your support request has been sent successfully!"}
            </Alert>
          )}

          {error && (
            <Alert severity="error" className="mb-4">
              {error.message || t("errorOccurred") || "An error occurred while sending your request."}
            </Alert>
          )}

          <form onSubmit={handleSubmit} className="space-y-6 mt-3">
            <TextField
              label={t("topic") || "Topic"}
              name="topic"
              value={form.topic}
              onChange={handleChange}
              fullWidth
              required
              variant="outlined"
              helperText={t("topicHelperText") || "Please provide a brief subject for your request"}
            />
            <TextField
              label={t("description") || "Description"}
              name="description"
              value={form.description}
              onChange={handleChange}
              fullWidth
              multiline
              rows={6}
              required
              variant="outlined"
              helperText={t("descriptionHelperText") || "Please describe your issue or question in detail"}
            />
            <button
              type="submit"
              disabled={loading || !currentUser}
              className="bg-button-bg hover:bg-primary-dark text-white px-8 py-3 rounded transition disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
            >
              {loading && (
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              )}
              {loading ? t("submitting") : t("submit")}
            </button>
          </form>
        </Box>
      </div>
    </>
  );
};

export default UserSupportPage;